import {observer} from 'mobx-react-lite';
import Table from './Table';

const KeyValueTable = ({rows}) => (
  <Table
    striped="odd"
    size="small"
    components={{
      header: {
        wrapper: () => null,
      },
    }}
    rowKey={(row) => row[0]}
    pagination={false}
    columns={[
      {
        key: 'key',
        dataIndex: 0,
        render: (x) => (
          <span style={{color: '#949494'}}>
            {
              (typeof x === 'string')
                ? x.toUpperCase()
                : x
            }
          </span>
        ),
      },
      {
        key: 'value',
        dataIndex: 1,
      },
    ]}
    dataSource={rows}
  />
);

export default observer(KeyValueTable);
